import { computed, onBeforeMount, ref } from 'vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormInputTextarea from '../FormInputTextarea/FormInputTextarea.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'
import fieldsConfig from './config/fieldsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetOpretHoldStepOne',
    components: {
        FormInputTextField,
        FormInputTextarea,
        StafetActions
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const teamName = ref('')
        const donationGoal = ref(0)
        const logo = ref(null)
        const description = ref('')
        const slogan = ref('')

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_CREATE_A_TEAM
            )

            if (props.holdData) {
                if (props.holdData.teamName) {
                    teamName.value = props.holdData.teamName
                    validateField('teamName', teamName.value)
                }

                if (props.holdData.donationGoal) {
                    donationGoal.value = props.holdData.donationGoal
                    validateField('donationGoal', donationGoal.value)
                }

                if (props.holdData.description) {
                    description.value = props.holdData.description
                    validateField('description', description.value)
                }

                if (props.holdData.slogan) {
                    slogan.value = props.holdData.slogan
                    validateField('slogan', slogan.value)
                }
            }

            if (storedFields) {
                if (getFieldValue(storedFields, 'teamName')) {
                    teamName.value = getFieldValue(storedFields, 'teamName')
                    validateField('teamName', teamName.value)
                }

                if (getFieldValue(storedFields, 'donationGoal')) {
                    donationGoal.value = getFieldValue(
                        storedFields,
                        'donationGoal'
                    )
                    validateField('donationGoal', donationGoal.value)
                }

                if (getFieldValue(storedFields, 'description')) {
                    description.value = getFieldValue(
                        storedFields,
                        'description'
                    )
                    validateField('description', description.value)
                }

                if (getFieldValue(storedFields, 'slogan')) {
                    slogan.value = getFieldValue(storedFields, 'slogan')
                    validateField('slogan', slogan.value)
                }
            }
        })

        const validateField = (fieldName, value) => {
            fieldsConfig.find((item) => item.name === fieldName).value = value
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                field.value = value
                fieldValidator(field)
            }
        }
        
        const onFileChange = (e) => {
            const files = e.target.files
            logo.value = files
            validateField('logo', files)
        }
        
        const showDescriptionErrorMessage = computed(() => {
            const field = fieldsConfig.find((field) => field.name === "description")
            return !field.validator(description.value) && props.displayInputError
        })

        const showTeamNameErrorMessage = computed(() => {
            return (
                !nonEmptyStringValidator(teamName.value) &&
                props.displayInputError
            )
        })

        const showDonationGoalErrorMessage = computed(() => {
            return donationGoal.value <= 0 && props.displayInputError
        })

        const showSloganErrorMessage = computed(() => {
            const field = fieldsConfig.find((field) => field.name === "slogan")
            return !field.validator(slogan.value) && props.displayInputError
        })

        const showLogoErrorMessage = computed(() => {
            const field = fieldsConfig.find((field) => field.name === "logo")
            return !field.validator(logo.value) && props.displayInputError
        })

        const stepModel = computed(() => {
            return fieldsConfig
        })

        return {
            teamName,
            donationGoal,
            logo,
            description,
            slogan,
            showTeamNameErrorMessage,
            showDonationGoalErrorMessage,
            showDescriptionErrorMessage,
            showSloganErrorMessage,
            showLogoErrorMessage,
            stepModel,
            validateField,
            onFileChange
        }
    }
}
